import { Box } from "@chakra-ui/react";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";

interface ContentContainerProps {
	bgColor?: string;
	children: React.ReactNode;
	noPadding?: boolean;
}

export const ContentContainer: React.FC<ContentContainerProps> = ({
	noPadding = false,
	bgColor = "white",
	children,
}) => {
	const defaultPaddingLeftRight = noPadding ? "0px" : "2px";
	const defaultPaddingTopBottom = noPadding ? "0px" : "2px";
	const smallPaddingLR = noPadding ? "0px" : "3px";
	const smallPaddingTB = noPadding ? "0px" : "2px";
	const medPaddingLR = noPadding ? "0px" : "5px";
	const medPaddingTB = noPadding ? "0px" : "5px";
	const lgPaddingLR = noPadding ? "0px" : "30px";
	const lgPaddingTB = noPadding ? "0px" : "8px";

	return (
		// <ErrorBoundary fallback="Sorry an unexpected error has occurred, please refresh and try again.">
		<Box
			as="div"
			width="100%"
			marginRight="auto"
			position="relative"
			paddingLeft={{
				base: defaultPaddingLeftRight,
				sm: smallPaddingLR,
				md: medPaddingLR,
				lg: lgPaddingLR,
			}}
			paddingRight={{
				base: defaultPaddingLeftRight,
				sm: smallPaddingLR,
				md: medPaddingLR,
				lg: lgPaddingLR,
			}}
			paddingTop={{
				base: defaultPaddingTopBottom,
				sm: smallPaddingTB,
				md: medPaddingTB,
				lg: lgPaddingTB,
			}}
			paddingBottom={{
				base: defaultPaddingTopBottom,
				sm: smallPaddingTB,
				md: medPaddingTB,
				lg: lgPaddingTB,
			}}
			backgroundColor={bgColor}
			overflow="auto"
			maxHeight="100vh"
		>
			{children}
		</Box>
		// </ErrorBoundary>
	);
};
